type IState = types.redux.rootReducer;
export const remoteConfigSelector = ({ settings }: IState) => settings?.remoteConfig?.sidebar;
